import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Hook to fetch a single editable homepage section (about/stats/timeline/outlets).
 * Returns { data, loading }.
 * The hook is fail-soft — network errors leave data as null so the component
 * falls back to its static defaults.
 */
export const useSiteContent = (section) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/site/content");
      const sec = data?.[section];
      setData(sec && Object.keys(sec).length ? sec : null);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [section]);

  useEffect(() => { reload(); }, [reload]);
  return { data, loading, reload };
};
